import { createLucideIcon } from "lucide-react";

export const Play = createLucideIcon(
    "Play",
    [
        [
            "path",
            {
                d: "M12.5944 8.56398C12.3587 9.45934 11.2451 10.092 9.01781 11.3574C6.86468 12.5806 5.78812 13.1922 4.92054 12.9464C4.56185 12.8447 4.23504 12.6517 3.97148 12.3858C3.33398 11.7426 3.33398 10.4951 3.33398 8C3.33398 5.50493 3.33398 4.2574 3.97148 3.61421C4.23504 3.3483 4.56185 3.15526 4.92054 3.05361C5.78812 2.80777 6.86468 3.41938 9.01781 4.64262C11.2451 5.90798 12.3587 6.54066 12.5944 7.43602C12.6916 7.80559 12.6916 8.19441 12.5944 8.56398Z",
                key: "10equu",
            },
        ],
    ],
);
